module.exports = __webpack_public_path__ + "img/block2-1.7112d115.svg";